angular.module('dnecom.component.currency')
    .service('CurrencyFormatter', function () {
        var symbolTable = {
            'usd': '$',
            'gbp': '£',
            'cad': '$',
            'aud': '$',
            'eur': '€',
            'rub': '₽',
            'php': '₱',
        };

        return {
            /**
             * Formats the amount according to:
             * - whether the multi-currency shop is enabled
             * - whether rounding to the nearest integer is enabled
             * - whether displaying the currency code is enabled
             *
             * Currency code will only be displayed when:
             * - currency symbol is NOT available for the particular code
             * - "currency code must be displayed" is enabled
             *
             * The formatter also makes sure to fallback to simple rounding
             * in case the Intl module is not available in current environment.
             * In case it is, we format the number using Intl to keep the correct
             * rounding. Some currencies are formatted to 3rd decimal place.
             *
             * @param amount
             * @param currencyCode
             * @returns string
             */
            format: function (amount, currencyCode) {
                currencyCode = currencyCode.toLowerCase();

                if (window.ies.store.currency.roundingEnabled) {
                    amount = _.round(amount, 0);
                } else if (_.has(window, 'Intl.NumberFormat')) {
                    amount = new Intl
                        .NumberFormat('en', { style: 'currency', currency: currencyCode, currencyDisplay: 'code' })
                        .format(amount)
                        .replace(currencyCode.toUpperCase(), '')
                        .trim();
                } else {
                    amount = _.round(amount, 2);
                }

                var hasSymbol = _.has(symbolTable, currencyCode);

                if(hasSymbol) {
                    amount = symbolTable[currencyCode] + amount;
                }

                if (window.ies.store.currency.codeEnabled
                    || !hasSymbol) {
                    amount = amount + " " + currencyCode.toUpperCase();
                }

                return amount;
            },
            formatReal: function (amount, currencyCode) {
                currencyCode = currencyCode.toLowerCase();

                if (_.has(window, 'Intl.NumberFormat')) {
                    amount = new Intl
                        .NumberFormat('en', { style: 'currency', currency: currencyCode, currencyDisplay: 'code' })
                        .format(amount)
                        .replace(currencyCode.toUpperCase(), '')
                        .trim();
                } else {
                    amount = _.round(amount, 2);
                }

                var hasSymbol = _.has(symbolTable, currencyCode);

                if(hasSymbol) {
                    amount = symbolTable[currencyCode] + amount;
                }

                if (window.ies.store.currency.codeEnabled
                    || !hasSymbol) {
                    amount = amount + " " + currencyCode.toUpperCase();
                }

                return amount;
            }
        };
    });
